import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { QbAccount } from '@/types/settings';

/**
 * Fetch the QBO Chart of Accounts. The backend caches the response for
 * 10 minutes. Used to populate GL account-mapping pickers.
 *
 * Pass `{ enabled: false }` to skip the fetch when QBO is not connected.
 */
export function useChartOfAccounts(options?: { enabled?: boolean }) {
  return useApiQuery<QbAccount[]>({
    queryKey: settingsKeys.qbAccounts(),
    queryFn: () => apiGet<QbAccount[]>(operationsClient, settingsEndpoints.qbAccounts()),
    showErrorToast: false,
    enabled: options?.enabled,
    staleTime: 10 * 60 * 1000, // backend cache is 10min — match it
  });
}
